/** Same-origin Nexus app functions. Caddy forwards /v1 to the gateway. */
export const RUSH_FN = '/v1/app/rush/fn';

export function rushFunctionPath(name: string): string {
  return `${RUSH_FN}/${name}`;
}

/**
 * Icons and animation frames are static files on the SPA.
 * Spaceship and flame art live under /sprites; player and rover frames
 * live in their own folders; everything else is /icons.
 */
export function publicAssetUrl(fileName: string): string {
  const file = (fileName.split('/').pop() || fileName).replace(/^\/+/, '');
  if (file.startsWith('rover-') && file.includes('frame')) return `/sprites/rover/${file}`;
  if (/^player\d-front-frame/.test(file)) return `/sprites/avatar/${file}`;
  if (file.startsWith('spaceship-') || file.startsWith('flame-')) return `/sprites/${file}`;
  return `/icons/${file}`;
}
